// WhatsApp vía Twilio (Masifi). Toda la lógica frontend de este gate vive acá; los archivos core solo
// importan de acá (touchpoint de import + 1 línea, igual que masifiWhatsappQr.js).
export const WHATSAPP_TWILIO_FEATURE = 'feature_whatsapp_twilio';

// E2E fix #10 (Marcos, owner decision 2026-09-23): la card de Twilio se oculta del asistente de alta por
// defecto (owner-scope, Super Admin la habilita por cuenta). Sin cambios cuando está habilitada: ningún
// cliente que ya la use pierde la card.
export const withTwilioVisibility = (providers, enabled) =>
  enabled ? providers : providers.filter(provider => provider.key !== 'twilio');
